export type SupplierSessionChangeAction = 'LOGIN' | 'LOGOUT'

interface SupplierSessionChangeMessage {
  type: 'USER_CHANGED'
  sourceId: string
  action: SupplierSessionChangeAction
}

const channelName = 'token'
const sourceId = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
  ? crypto.randomUUID()
  : `${Date.now()}-${Math.random().toString(36).slice(2)}`

function supportsBroadcastChannel(): boolean {
  return typeof BroadcastChannel !== 'undefined'
}

export function broadcastSupplierSessionChange(action: SupplierSessionChangeAction) {
  if (!supportsBroadcastChannel()) return
  const channel = new BroadcastChannel(channelName)
  const message: SupplierSessionChangeMessage = { type: 'USER_CHANGED', sourceId, action }
  channel.postMessage(message)
  channel.close()
}

export function subscribeSupplierSessionChanges(onExternalChange: () => void): () => void {
  if (!supportsBroadcastChannel()) return () => undefined
  const channel = new BroadcastChannel(channelName)
  channel.onmessage = (event: MessageEvent<unknown>) => {
    if (typeof event.data !== 'object' || event.data === null) return
    const message = event.data as { type?: unknown; sourceId?: unknown }
    if (message.type !== 'USER_CHANGED') return
    if (message.sourceId === sourceId) return
    onExternalChange()
  }
  return () => channel.close()
}
